module.exports = __webpack_public_path__ + "img/inspiration_03@2x.85613f6.webp";